import { DrEntity } from './dr-entity';
import { DrObject } from '../models/dr-object';
import { isNullOrUndefined } from './utils';
import * as _ from 'underscore';

export class PasswordCrackingSettings extends DrEntity {
    bruteCustom: boolean;
    bruteCustomChars: string;
    bruteDigits: boolean;
    bruteForce: boolean;
    bruteLowerCase: boolean;
    bruteMaxChars: number;
    bruteMinChars: number;
    bruteSpace: boolean;
    bruteSymbols: boolean;
    bruteUpperCase: boolean;
    contextDictionary: boolean;
    crackingDictionary: boolean;
    dictionaryCapitalizeAllLetters: boolean;
    dictionaryCapitalizeAnyLetters: boolean;
    dictionaryCapitalizeFirstLetter: boolean;
    dictionaryReverseWord: boolean;
    dictionaryUseSubstitution: boolean;
    goldenDictionary: boolean;
    passwordCrackingDictionaryName: string;
    passwordCrackingDictionarySize: number;
    passwordCrackingDictionaryUploadDate: string;
    passwordCrackingDictionaryUploadUser: string;
    passwordGoldenDictionaryName: string;
    passwordGoldenDictionarySize: number;
    passwordGoldenDictionaryUploadDate: string;
    passwordGoldenDictionaryUploadUser: string;
    foundPasswordCount: number;
    knownPassswordCount: number;
    frequentlyUsedPasswordCount: number;
    knownPassswordDictionaryUpdateDate: string;
    knownPassswordDictionaryUpdatedBy: string;
    frequentlyUsedPassswordDictionaryUpdateDate: string;
    frequentlyUsedPassswordDictionaryUpdatedBy: string;


    constructor(value?: Partial<PasswordCrackingSettings>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}


export class PasswordCrackingSettingsViewModel {

    model: Partial<PasswordCrackingSettings>;
    original: Partial<PasswordCrackingSettings>;

    // temporarily displayed values until save
    bruteMaxChars: number;
    bruteMinChars: number;

    inputFilePasswordList: Array<any> = new Array<any>();
    originalInputFilePasswordList: Array<any> = new Array<any>();
    inputFilePasswordDictionary: Array<any> = new Array<any>();
    originalInputFilePasswordDictionary: Array<any> = new Array<any>();


    constructor(value?: Partial<PasswordCrackingSettings>) {
        if (value) {
            this.model = value;
        }

        if (this.model) {
            this.original = new PasswordCrackingSettings(this.model);


            this.bruteMinChars = this.original.bruteMinChars = this.model.bruteMinChars === 0 ? 1 : this.model.bruteMinChars;
            this.bruteMaxChars = this.original.bruteMaxChars = this.model.bruteMaxChars === 0 ? 7 : this.model.bruteMaxChars;

            if (isNullOrUndefined(this.model.passwordGoldenDictionaryName)) {
                this.resetInputFilePasswordList(true);
            }

            if (DrObject.isEmpty(this.model.bruteCustomChars)) {
                this.original.bruteCustomChars = '';
            }

            // input file password list initialization
            this.inputFilePasswordList = this.model.passwordGoldenDictionaryName ?
                [{ file: new File([''], this.model.passwordGoldenDictionaryName, { type: 'text/plain' }) }] : [];
            this.originalInputFilePasswordList = this.inputFilePasswordList;

            if (isNullOrUndefined(this.model.passwordCrackingDictionaryName)) {
                this.resetInputFilePasswordDictionary(true);
            }

            // input file password dictionary initialization
            this.inputFilePasswordDictionary = this.model.passwordCrackingDictionaryName ?
                [{ file: new File([''], this.model.passwordCrackingDictionaryName, { type: 'text/plain' }) }] : [];
            this.originalInputFilePasswordDictionary = this.inputFilePasswordDictionary;
        }
    }

    isDirty(): boolean {

        if (this.model.bruteCustom !== this.original.bruteCustom) {
            return true;
        }

        if (DrObject.isValueDirty(this.model.bruteCustomChars, this.original.bruteCustomChars)) {
            return true;
        }

        if (this.model.bruteDigits !== this.original.bruteDigits) {
            return true;
        }

        if (this.model.bruteForce !== this.original.bruteForce) {
            return true;
        }

        if (this.model.bruteLowerCase !== this.original.bruteLowerCase) {
            return true;
        }

        if (this.bruteMinChars !== this.original.bruteMinChars) {
            this.model.bruteMinChars = this.bruteMinChars;
            return true;
        }

        if (this.bruteMaxChars !== this.original.bruteMaxChars) {
            this.model.bruteMaxChars = this.bruteMaxChars;
            return true;
        }

        if (this.model.bruteSpace !== this.original.bruteSpace) {
            return true;
        }

        if (this.model.bruteSymbols !== this.original.bruteSymbols) {
            return true;
        }

        if (this.model.bruteUpperCase !== this.original.bruteUpperCase) {
            return true;
        }

        if (this.model.contextDictionary !== this.original.contextDictionary) {
            return true;
        }

        if (this.model.crackingDictionary !== this.original.crackingDictionary) {
            return true;
        }

        if (this.model.dictionaryCapitalizeAllLetters !== this.original.dictionaryCapitalizeAllLetters) {
            return true;
        }

        if (this.model.dictionaryCapitalizeAnyLetters !== this.original.dictionaryCapitalizeAnyLetters) {
            return true;
        }

        if (this.model.dictionaryCapitalizeFirstLetter !== this.original.dictionaryCapitalizeFirstLetter) {
            return true;
        }

        if (this.model.dictionaryReverseWord !== this.original.dictionaryReverseWord) {
            return true;
        }

        if (this.model.dictionaryUseSubstitution !== this.original.dictionaryUseSubstitution) {
            return true;
        }

        if (this.model.goldenDictionary !== this.original.goldenDictionary) {
            return true;
        }

        return false;
    }

    resetInputFilePasswordList(updateOriginal?: boolean): void {
        if (!isNullOrUndefined(this.inputFilePasswordList) && !isNullOrUndefined(this.originalInputFilePasswordList)) {
            this.inputFilePasswordList = [];
            this.model.passwordGoldenDictionaryName = null;
            this.model.passwordGoldenDictionarySize = 0;
            this.model.passwordGoldenDictionaryUploadDate = null;
            this.model.passwordGoldenDictionaryUploadUser = null;

            if (updateOriginal) {
                this.original.passwordGoldenDictionaryName = this.model.passwordGoldenDictionaryName;
                this.original.passwordGoldenDictionarySize = this.model.passwordGoldenDictionarySize;
                this.original.passwordGoldenDictionaryUploadDate = this.model.passwordGoldenDictionaryUploadDate;
                this.original.passwordGoldenDictionaryUploadUser = this.model.passwordGoldenDictionaryUploadUser;
            }
        }
    }

    resetInputFilePasswordDictionary(updateOriginal?: boolean): void {
        if (!isNullOrUndefined(this.inputFilePasswordDictionary) && !isNullOrUndefined(this.originalInputFilePasswordDictionary)) {
            this.inputFilePasswordDictionary = [];
            this.model.passwordCrackingDictionaryName = null;
            this.model.passwordCrackingDictionarySize = 0;
            this.model.passwordCrackingDictionaryUploadDate = null;
            this.model.passwordCrackingDictionaryUploadUser = null;

            if (updateOriginal) {
                this.original.passwordCrackingDictionaryName = this.model.passwordCrackingDictionaryName;
                this.original.passwordCrackingDictionarySize = this.model.passwordCrackingDictionarySize;
                this.original.passwordCrackingDictionaryUploadDate = this.model.passwordCrackingDictionaryUploadDate;
                this.original.passwordCrackingDictionaryUploadUser = this.model.passwordCrackingDictionaryUploadUser;
            }
        }
    }

}
